import React from 'react'
import { CustomerSubscriptionsData } from '../../../customer/customer-subscription'

export const CustomersSubscriptions = () => {
  return (
    <div><CustomerSubscriptionsData/></div>
  )
}
